import Vue from 'vue'
import Vuex from 'vuex'
import user from './store/modules/user'
import auth from './store/modules/auth'
import companies from './store/companies'
import users from './store/users'
import invites from './store/invites'
import counterparties from './store/counterparties'
import snack from './store/snack-bar-modals'
import banks from './store/banks'
import companyBankAccount from './store/company-bank-account'
import companyBankAccountSettings from './store/company-bank-account-settings'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    auth,
    companies,
    invites,
    counterparties,
    banks,
    snackBarModules: snack,
    companyBankAccount,
    companyBankAccountSettings,
    users,
  },
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg',
    drawer: true,
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload
    },
  },
})
